import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat' // For 'MMMM Do YYYY' format
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/de'
import { defineNuxtPlugin } from 'nuxt/app'

dayjs.extend(localizedFormat)
dayjs.extend(customParseFormat)

export default defineNuxtPlugin(() => {
  return {
    provide: {
      dayjs,
    },
  }
})
